import { render, staticRenderFns } from "./Fixed.vue?vue&type=template&id=4c8331e8"
import script from "./Fixed.vue?vue&type=script&lang=js"
export * from "./Fixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports